<template>
  <button
      class="tag-text-button"
      :class="{
      'tag-text-button--no-inverted': !inverted,
      'tag-text-button--inverted': inverted,
    }"
  >
    {{ sanitizedTitle }}
  </button>
</template>

<script setup lang="ts">
import {computed} from "vue";
import {sanitizeMarkedHeading} from "~/utils/data-transformers";

const props = defineProps({
  title: String,
  inverted: Boolean
})

const sanitizedTitle = computed(() => {
  return sanitizeMarkedHeading(props.title)
})

</script>

<style scoped lang="postcss">
.tag-text-button {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  border-radius: 55px;
  border-width: 1px;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 7px;
  padding-bottom: 7px;
  font-size: 13px;
  font-weight: 500;
  text-transform: uppercase;
  line-height: 1;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

  &--no-inverted {
    border-color: var(--color-blue-aqua);
    color: var(--color-blue-aqua);

    &:hover {
      background-color: var(--color-blue-aqua);
      color: var(--color-blue-prussian);
    }
  }

  &--inverted {
    border-color: var(--color-blue-aqua);
    background-color: var(--color-blue-aqua);
    color: var(--color-blue-prussian);

    &:hover {
      background-color: var(--color-blue-prussian);
      color: var(--color-blue-aqua);
    }
  }
}
</style>
